<header>
  <h1 mat-dialog-title class="confirm-dialog">
    <i *ngIf="data.titleIcon.startsWith('bhi-')" class="{{data.titleIcon}}"></i>
    <i *ngIf="data.titleIcon.endsWith('-KyloeIcon')" class="{{data.titleIcon}}"></i>
    <i *ngIf="!data.titleIcon.startsWith('bhi-') && !data.titleIcon.endsWith('-KyloeIcon')" [class]="(data.outlinedIcons ? 'material-icons-outlined' : 'material-icons') + ' notranslate'">{{data.titleIcon}}</i>
    {{data.title}}
  </h1>
</header>
<div mat-dialog-content class="grid-2">
  <i *ngIf="data.messageIcon.startsWith('bhi-')" class="{{data.messageIcon}}"></i>
  <i *ngIf="!data.messageIcon.startsWith('bhi-')" [class]="(data.outlinedIcons ? 'material-icons-outlined' : 'material-icons') + ' notranslate'">{{data.messageIcon}}</i>
  <h2 *ngIf="data.message" [innerHTML]="data.message"></h2>
  <h2 *ngIf="!data.message" class="grey">Rule has no name</h2>
</div>
<section mat-dialog-actions class="footer-btns">
  <button *ngIf="!data.hideCancelButton" mat-button (click)="onNoClick()" theme-style="nav" appRipple>No</button>
  <button *ngIf="data.alternativeButtonText" mat-button (click)="onAlternativeClick()" theme-style="nav" appRipple>
    <i *ngIf="data.alternativeButtonIcon" [class]="(data.outlinedIcons ? 'material-icons-outlined' : 'material-icons') + ' notranslate'">{{data.alternativeButtonIcon}}</i>
    {{data.alternativeButtonText}}
  </button>
  <button mat-button [mat-dialog-close]="data" class="danger-btn-hover" theme-style="nav" appRipple>
    <i *ngIf="data.confirmButtonIcon" [class]="(data.outlinedIcons ? 'material-icons-outlined' : 'material-icons') + ' notranslate'">{{data.confirmButtonIcon}}</i>
    {{data.confirmButtonText}}
  </button>
</section>
